var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "12", viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg463464017a)" },
      React.createElement("path", { d: "M11.255 6.392v4.564H2.501V6.392h8.754zM12 5.647H1.756v6.054H12V5.647z" }),
      React.createElement("path", { d: "M9.206 5.647l1.049 1.049c-.008.039-.024.074-.024.115 0 .334.271.604.605.604.04 0 .076-.015.115-.023L12 8.442V5.646H9.206zM9.905 9.278a.604.604 0 1 0 0-1.208.604.604 0 0 0 0 1.208zM6.878 10.264c1.01 0 1.828-.712 1.828-1.59 0-.878-.818-1.59-1.828-1.59-1.01 0-1.828.712-1.828 1.59 0 .878.818 1.59 1.828 1.59zM3.851 9.278a.604.604 0 1 0 0-1.208.604.604 0 0 0 0 1.208zM1.756 8.441l1.049-1.049c.038.008.074.024.115.024.334 0 .604-.27.604-.605 0-.04-.015-.076-.023-.115L4.55 5.647H1.756v2.794zM3.524 10.537a.604.604 0 0 0-.604-.604c-.04 0-.076.015-.115.022l-1.05-1.048V11.7H4.55L3.5 10.652c.008-.039.023-.075.023-.115zM10.836 9.932a.604.604 0 0 0-.604.604c0 .042.015.077.023.116L9.206 11.7H12V8.907l-1.049 1.048c-.038-.008-.074-.023-.115-.023zM8.602 4.564a.604.604 0 1 0 0-1.208.604.604 0 0 0 0 1.208z" }),
      React.createElement("path", { d: "M1.057 5.647c0-.385.313-.698.699-.698h.382l.017-.06 5.39-2.952.413.12c.011.037.016.077.036.112.16.294.527.4.82.24.035-.02.06-.05.089-.075l.413.12.94 1.715-.121.413c-.037.011-.076.015-.112.035a.599.599 0 0 0-.275.332h1.784l-1.205-2.2L8.986.3l-2.45 1.342L2.45 3.878 0 5.22l1.057 1.93V5.648z" }),
      React.createElement("path", { d: "M5.183 4.02a1.97 1.97 0 0 0-.861.929H7.69a1.382 1.382 0 0 0-.14-.412c-.422-.77-1.481-1.001-2.367-.517z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg463464017a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h12v12H0z" })
      )
    )
  );
});